import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import login from "../../store/actions/user.actions";
import logo from "../../logo.png";
import "./style.css";

class Login extends Component {
  constructor() {
    super();
    this.state = {
      Email: "",
      senha: "",
      buttonDisabled: true,
      showPassword: false,
    };
    this.logado = this.logado.bind(this);
    this.change = this.change.bind(this);
    this.togglePassword = this.togglePassword.bind(this);
  }

  change(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value }, this.logado);
  }

  togglePassword() {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  }

  logado() {
    const { Email, senha } = this.state;
    const rgx = /\S+@\S+\.\S+/;
    const testeEmail = rgx.test(Email);
    const mininoDigitos = 6;
    if (testeEmail && senha.length > mininoDigitos) {
      this.setState({
        buttonDisabled: false,
      });
    } else {
      this.setState({
        buttonDisabled: true,
      });
    }
  }

  render() {
    const { history, setEmail } = this.props;
    const { Email, senha, buttonDisabled, showPassword } = this.state;
    const objUser = { email: Email };
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <img
              src={logo}
              className="logo"
              alt="Logo Kitchen Memories"
            />
            <span className="login-badge">Warm Culinary Journal</span>
            <h1 className="login-title">Kitchen Memories</h1>
            <p className="login-subtitle">
              Sua caderneta pessoal de sabores, segredos e lembranças da cozinha.
            </p>
            <div className="login-tip-box" role="note">
              <span className="tip-icon" role="img" aria-label="Dica">💡</span>
              <p className="tip-text">
                <strong>Observação de Acesso:</strong> Para entrar e explorar à vontade, digite <strong>qualquer e-mail fictício</strong> (ex: <em>chef@cozinha.com</em>) e uma senha com <strong>qualquer combinação de no mínimo 8 dígitos</strong>.
              </p>
            </div>
          </div>

          <form
            className="login-form"
            onSubmit={(e) => {
              e.preventDefault();
              if (!buttonDisabled) {
                localStorage.setItem("mealsToken", 1);
                localStorage.setItem("cocktailsToken", 1);
                localStorage.setItem("user", JSON.stringify(objUser));
                setEmail(objUser.email);
                history.push("/comidas");
              }
            }}
          >
            <div className="form-group-custom">
              <label htmlFor="email-input" className="input-label">
                Endereço de E-mail
              </label>
              <input
                id="email-input"
                className="login-input"
                type="email"
                name="Email"
                value={Email}
                placeholder="exemplo@chef.com"
                data-testid="email-input"
                autoComplete="email"
                onChange={(event) => this.change(event)}
              />
            </div>

            <div className="form-group-custom">
              <div className="password-header">
                <label htmlFor="password-input" className="input-label">
                  Senha de Acesso
                </label>
                <button
                  type="button"
                  className="password-toggle-btn"
                  onClick={this.togglePassword}
                  aria-label={showPassword ? "Ocultar senha" : "Exibir senha"}
                >
                  {showPassword ? "Ocultar" : "Mostrar"}
                </button>
              </div>
              <input
                id="password-input"
                className="login-input"
                type={showPassword ? "text" : "password"}
                name="senha"
                value={senha}
                placeholder="Mínimo de 8 caracteres"
                data-testid="password-input"
                autoComplete="current-password"
                onChange={(event) => this.change(event)}
              />
            </div>

            <Button
              className="btn-login-custom"
              type="submit"
              data-testid="login-submit-btn"
              disabled={buttonDisabled}
            >
              <span>Entrar no Jornal</span>
            </Button>
          </form>
          
          <div className="login-footer">
            <p>Guarde com carinho cada receita e brinde à boa mesa.</p>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setEmail: (email) => dispatch(login(email)),
});

export default connect(null, mapDispatchToProps)(Login);

Login.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  setEmail: PropTypes.func.isRequired,
};

